module.exports = __webpack_public_path__ + "static/media/voltgroom-replacement-blade-1.3c3885b5.png";